import http from '@/plugins/http'
const adminApi = process.env.VUE_APP_ADMIN_API;

//获取节点树
export const getNode = (params={}) => {
    const url = adminApi  + 'report/car/coreScene/tree'
    return http.fetchGet(url, params);
}

//获取节点详情
export const getNodeDetail = (params={}) => {
    const url = adminApi  + 'report/car/coreScene/video'
    return http.fetchGet(url, params);
}

//获取相关视频
export const getRelaVideo = (params={}) => {
    const url = adminApi  + 'report/car/coreScene/relateVideo'
    return http.fetchGet(url, params);
}
